export var colors = {
  WomOriginal: '#491966',
  WomCorp: '#4D008C',
  WomCorp20: '#DBCCE8',
  WomCorp40: '#A67FC5',
  WomCorp80: '#270046',
  WomCTA: '#E92070',
  WomCTA20: '#FBD2E2',
  WomCTA40: '#F48FB7',
  WomCTA80: '#751038',
  NotificacionesRojo: '#FD3A4A',
  NotificacionBackgroundRojo: '#FFE2E4',
  NotificacionesVerde: '#33CC9E',
  NotificacionBackgroundVerde: '#E0F7F1',
  NotificacionesVerdeHover: '#078B64',
  NotificacionesVerdeSuccess: '#1A664F',
  NotificacionesAmarilloHover: '#FF8723',
  NotificacionesAmarillo: '#FFC71E',
  NotificacionBackgroundAmarillo: '#FFF7DD',
  NotificacionesAmarilloComplementario: '#804412',
  NotificacionesAzul: '#49AAE0',
  Neutros0: '#FFFFFF',
  Neutros5: '#EFF1F3',
  Neutros5_60: 'rgba(239, 241, 243, 0.6)',
  NeutrosDeshabilitado: '#E2E6EA',
  Neutros20: '#C9CFD7',
  Neutros40: '#8D94A5',
  Neutros60: '#494C66',
  Neutros90: '#0E141D',
  GradientesAlphaH: 'linear-gradient(270deg, #ED1E79 0%, #451287 100%)',
  GradienteMultiColor: 'linear-gradient(180deg, #FF5B5B 0%, #FFCC80 14.28%, #E9FF90 28.56%, #BFF59D 42.84%, #A9EDD8 57.12%, #C7C4ED 71.4%, #FFC1EE 85.68%)',
  Wom90: '#574466'
};